import React from 'react';
import { Icon, ICONS } from '@/components/brand';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  destructive?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  isLoading = false,
  destructive = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: 'rgba(8, 8, 9, 0.78)', backdropFilter: 'blur(6px)' }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
    >
      <div
        className="sh-card"
        style={{ maxWidth: 460, width: '100%', margin: '0 16px', padding: '28px 28px 24px' }}
      >
        <div className="flex items-center justify-between" style={{ marginBottom: 18 }}>
          <span className={`sh-pill ${destructive ? 'sh-pill-danger' : 'sh-pill-warn'}`}>Confirm</span>
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="sh-btn sh-btn-ghost sh-btn-sm"
            aria-label="Close"
            style={{ padding: 6 }}
          >
            <Icon d={ICONS.close} size={14} />
          </button>
        </div>

        <h2 id="confirm-dialog-title" className="sh-h2" style={{ marginBottom: 8 }}>
          {title}
        </h2>
        <p style={{ color: 'var(--text-2)', fontSize: 13, whiteSpace: 'pre-line', lineHeight: 1.55, marginBottom: 24 }}>
          {message}
        </p>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className={`sh-btn ${destructive ? 'sh-btn-danger' : 'sh-btn-primary'}`}
            style={{ flex: 1 }}
          >
            {isLoading ? 'Processing…' : confirmText}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="sh-btn"
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};
